/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

nve-file > input {
  color: var(--color);
}

nve-file > input::file-selector-button {
  background: var(--background);
  padding: var(--padding);
  height: var(--height);
  width: var(--width);
  border-radius: var(--border-radius);
  border: var(--border);
  text-decoration: var(--text-decoration);
  font-weight: var(--font-weight);
  font-size: var(--font-size);
  cursor: var(--cursor);
  gap: var(--gap);
  margin-inline-end: var(--nve-ref-space-sm);
  display: inline-flex;
  place-items: center;
  appearance: none;
  line-height: 1.2em;
}

nve-file > input::file-selector-button:hover {
  --color: var(--nve-sys-interaction-hover-color);
  --background: var(--nve-sys-interaction-background);
}

nve-file > input::file-selector-button:active {
  --color: var(--nve-sys-interaction-active-color);
  --background: var(--nve-sys-interaction-background);
}
